import { render, staticRenderFns } from "./CareLebelLabel.vue?vue&type=template&id=a7767506&scoped=true&lang=pug"
import script from "./CareLebelLabel.vue?vue&type=script&lang=ts"
export * from "./CareLebelLabel.vue?vue&type=script&lang=ts"
import style0 from "./CareLebelLabel.vue?vue&type=style&index=0&id=a7767506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7767506",
  null
  
)

export default component.exports